import Parse from 'parse';
Parse.initialize(
  'PFIYect6yceEsU1m43fONUUKbJe89SRBZRuzJOGj',
  '0L4YKtVRqey2vRG0hjemm9TKb4edjNBSnZXC5Lni'
);
export default Parse;



/** WEBPACK FOOTER **
 ** ./src/Parse.js
 **/